/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Fw_Tpl_UsesInputs */

const en_fw_tpl_uses = /** @type {(inputs: Fw_Tpl_UsesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} uses`)
};

const id_fw_tpl_uses = /** @type {(inputs: Fw_Tpl_UsesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} kali dipakai`)
};

/**
* | output |
* | --- |
* | "{n} uses" |
*
* @param {Fw_Tpl_UsesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_tpl_uses = /** @type {((inputs: Fw_Tpl_UsesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Tpl_UsesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_tpl_uses(inputs)
	return en_fw_tpl_uses(inputs)
});